import {
  AuthLayoutSkeleton,
  initFlowbite,
  Navigate,
  Outlet,
  useAuthStore,
  useEffect,
  useLocation,
  usePermissionsSync,
  useState,
} from "@";
import NavBar from "./NavBar.jsx";
import SideBar from "./SideBar.jsx";

const AuthLayout = () => {
  const location = useLocation();
  const { user } = useAuthStore();
  usePermissionsSync();
  const [isLoading, setIsLoading] = useState(true);

  // Set loading state to false after component mounts
  useEffect(() => {
    setIsLoading(false);
  }, []);

  // Redirect to login if user is not authenticated
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Initialize Flowbite and scroll to top on location change
  useEffect(() => {
    const timer = setTimeout(() => initFlowbite(), 50);
    window.scrollTo(0, 0);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Re-bind Flowbite handlers when permissions change so newly-visible
  // sidebar dropdowns become clickable without a page reload.
  useEffect(() => {
    if (!user?.userPermissions) return;
    const timer = setTimeout(() => initFlowbite(), 50);
    return () => clearTimeout(timer);
  }, [user?.userPermissions]);

  return (
    <>
      {/* Show loading skeleton if still loading */}
      {isLoading && <AuthLayoutSkeleton />}
      <div className="flex ">
        <SideBar />
        <NavBar />

        <div className="main-container relative w-full pt-[65px] lg:ms-[250px] lg:w-[calc(100%-250px)] print:pt-0">
          <main className="min-h-screen px-3 pb-12 md:px-5">
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
